/* eslint-disable eqeqeq, camelcase */
/* eslint-disable */
import Vue from 'vue'
export default ({
  namespaced: true,
  state: {
    view: 'customField',
    values: [],
    files: {},
    // idFile Armazena o ultimo id auxiliar dos arquivos, serve para poder saber de qual registro é o determinado arquivo, pois os registros de arquivos são adicionados antes de irem pro banco
    idFile: 0,
    // indexFile, usado para mostra que está no final dos arquivos, pois a medida que vai salvando vai adicionando 1, não pode usar o idFile para isso, pois caso tenha um arquivo muito grande e o usuário adicione outros arquivos durante o update, pode acabar tendo ids iguais para arquivos diferentes
    indexFile: 0,
  },
  getters: {
    values: state => {
      return state.values
    },
    // pega as opções para mostra no select quando está na inclusão de tarefa ou tarefa modelo ou quando o usuário entra novamente nas opções
    options: state => (custom_field_id) => {
      // pega o id do campo passado, busca e depois pega as opções do campos personalizado encontrado
      let field = state.values.find((val) => { return val['id'] == custom_field_id })
      let options = (field && field['options']) ? field['options'] : []
      return options
    },
    getFile: state => (custom_field_id, file_id)  => {
      // pega o arquivo de acordo com o id passado
      let file = null
      file = state.files[custom_field_id]
      if (file) file = file.find((val) => { return val.get('id') == file_id })
      return file
    },
  },
  mutations: {
    // change_indexFile criado pois em alguns momentos devem ser zerado o index do file, exemplo quando o usuário sai da inclusão de tarefa 
    close_files (state, payload) {
      state.indexFile = 0
      state.files = {}
    },
    change_values (state, payload) {
      state.values = payload
    },
    add_value (state, payload) {
      state.values.push(payload)
    },
    edit_value (state, payload) {
      let customField = state.values.find((val) => { return val.id == payload['id'] })
      Object.assign(customField, payload)
    },
    delete_value (state, payload) {
      state.values = state.values.filter((val) => { return val.id != payload })
    },
    // Mutations abaixo lidam com as opções do campo de seleção dos campos personalizados
    add_option (state, payload) {
      let customField = state.values.find((val) => { return val.id == payload['custom_field_id'] })
      // caso não tenha options adiciona
      customField['options'] = customField['options'] ? customField['options'] : []
      customField['options'].push(payload)
    },
    edit_option (state, payload) {
      let customField = state.values.find((val) => { return val.id == payload['custom_field_id'] })
      let option = customField['options'].find((val) => { return val.id == payload['id'] })
      Object.assign(option, payload)
    },
    delete_option (state, payload) {
      let customField = state.values.find((val) => { return val.id == payload['custom_field_id'] })
      customField['options'] = customField['options'].filter((val) => { return val.id != payload['id'] })
    },
    // Mutations adicionar os arquivos que veem do socket do campo de seleção dos campos personalizados
    add_file (state, payload) {
      let customField = state.values.find((val) => { return val.id == payload['custom_field_id'] })
      // caso não tenha options adiciona
      customField['files'] = customField['files'] ? customField['files'] : []
      customField['files'].push(payload)
    },
    // Mutations deleta os arquivos que veem do socket do campo de seleção dos campos personalizados
    delete_file (state, payload) {
      let customField = state.values.find((val) => { return val.id == payload['custom_field_id'] })
      if (customField['files']) customField['files'] = customField['files'].filter((val) => { return val.id != payload['id'] })
    }
  },
  actions: {
    add_files (context, payload) {
      return new Promise((resolve, reject) => {
        let field = context.state.values.find((val) => { return val.id == payload['custom_field_id'] })
        // Caso não tenha a propriedade naquela posição cria com [] para pode incluir valores no array com push
        if (!context.state.files.hasOwnProperty(payload['custom_field_id'])) context.state.files[payload['custom_field_id']] = []
        // percorre todos os arquivos adicionados para inserilos na variavel com os devidos campos preenchidos
        if (payload['files'])
        for (var i = 0; i < payload['files'].length; i++) {
          let file = payload['files'][i]
          let fullName = file.name.split(/\.(?=[^\.]+$)/)
          // verifica se está em alguns formatos que não são aceitos
          if (['exe', 'sql', 'cs', 'msi'].includes(fullName[1])) {
            // adiciona os registro de arquvio para mostrar no front
            if (!Array.isArray(field['files'])) field['files'] = []
            field['files'].push({error: 'Formato do arquivo não aceito', id: context.state.idFile, id_text: fullName[0], size: file.size, extension: fullName[1], user_id: payload['user_id'], custom_field_id: payload['custom_field_id'], task_id: payload['task_id'], password: null, create: true, loading_upload: false, loading_value_upload: 0})
          } else {
            let formData = new FormData()
            context.state.idFile--
            context.state.indexFile++
            // Monta os dados no formData que irão para a tabela file
            formData.append('id', context.state.idFile)
            formData.append('file', file, file.name)
            formData.append('custom_field_id', payload['custom_field_id'])
            formData.append('task_id', payload['task_id'])
            formData.append('user_id', payload['user_id'])
            formData.append('company_id', payload['company_id'])
            formData.append('connection_company_id', payload['connection_company_id'])
            // Inclui um formdata completo para cada arquivo 
            context.state.files[payload['custom_field_id']].push(formData)
            // adiciona os registro de arquvio para mostrar no front
            if (!Array.isArray(field['files'])) field['files'] = []
            field['files'].push({id: context.state.idFile, id_text: fullName[0], size: file.size, extension: fullName[1], user_id: payload['user_id'], custom_field_id: payload['custom_field_id'], task_id: payload['task_id'], password: null, create: true, loading_upload: false, loading_value_upload: 0})
          }
        }
        // verifica se de salvar no banco
        if (payload['save_bd']) {
          // caso não tenha arquivos já fecha o processo
          if (context.state.indexFile === 0) {
            resolve(true)
          }
          // armazena todos os arquivos adicionados, para mandar na resposta quando terminar de salvar todos
          let resFiles = []
          // insere um indexFile dentro do stateFiles para armazenar o index e ir decrementando, é necessário pois quando é adicionado varias tarefas de uma vez(varios cliente), precisa ter o index para cada tarefa
          let indexFile = 0
          indexFile = context.state.indexFile
          // caso seja para salvar no banco, já adiciona o arquivo
          for (var key in context.state.files) {
            // Busca o campo personalizado do arquivo para substituir as informações
            let customField = context.state.values.find((val) => { return val.id == key })
            // pega todos os arquivos
            let stateFiles = context.state.files[key]
            // Faz um loop em todos os arquivo q
            stateFiles.forEach((stateFile) => {
              // Pega o arquivo que será adicionado no momento
              let customFieldFiles = customField['files'].find((val) => { return val.id == stateFile.get('id') })
              if (customFieldFiles) {
                // seta true para o loading começar a rodar
                customFieldFiles['loading_upload'] = true
                // caso tenha sido passado o task_id, altera todos os registros para o id da tarefa, pois na inclusão de uma tarefa os ids são passados como 0, e apos inserir a tarefa deve ser alterado os ids no arquivos para salvar corretamente
                if (payload['task_id'] && payload['task_id'] > 0) {
                  customFieldFiles['task_id'] = payload['task_id']
                  stateFile.append('task_id', payload['task_id'])
                }
                Vue.http.post('api/customField/upload', stateFile, {
                  progress (e) {
                    if (e.lengthComputable) {
                      customFieldFiles['loading_value_upload'] = Math.floor(e.loaded / e.total * 100)
                    }
                  }
                }).then(res => {
                  indexFile--
                  // context.state.indexFile--
                  stateFile = null
                  customFieldFiles['loading_upload'] = false
                  // Substitui os valoresde cada arquivo assim que ele for salvo
                  // ja coloca o create false, pois depois que salva o arquvios não fica mais em modo de criação
                  Object.assign(customFieldFiles, res.body, {create: false});
                  resFiles.push(res.body)
                  // caso o indexFile seja 0, significa que já chegou no ultimo arquivo, retornando que deu certo
                  if (indexFile === 0) {
                    resolve(resFiles)
                  }
                }, err => {
                  console.log(err)
                  indexFile--
                  // context.state.indexFile--
                  stateFile = null
                  customFieldFiles['loading_upload'] = false
                  if (err.body.message.includes('limit|')) {
                    // Substitui os valores de cada arquivo assim que ele for salvo
                    // ja coloca o create false, pois depois que salva o arquvios não fica mais em modo de criação
                    Object.assign(customFieldFiles, {error: 'Limite de memória do plano exedida'});
                  } else {
                    Object.assign(customFieldFiles, {error: 'Não foi possível incluir o arquivo'});
                  }
                  // caso o indexFile seja 0, significa que já chegou no ultimo arquivo, retornando que deu certo
                  reject(err)
                }).finally(() => {
                  if (indexFile === 0) {
                    // caso o clean_form não seja false então zera o form, ele pode não pedir pra zerar quando precisa adicionar varios arquivos(inclusão de tarefa com varios cliente)
                    if (!payload.hasOwnProperty('clean_form') || payload['clean_form'] !== false) {
                      // quando deleta o arquivo tira um index indexFile
                      context.state.indexFile--
                      // apos ter sido salvo no banco remove os registros, para que estes não sejam adicionados posteriomente
                      delete context.state.files[key]
                    }
                  }
                })
                // else - caso não tenha encontrado o arquivos então tira ele da lista
              } else {
                indexFile--
                stateFile = null
                // caso o indexFile seja 0, significa que já chegou no ultimo arquivo, retornando que deu certo
                if (indexFile === 0) {
                  resolve(resFiles)
                }
              }
            })
          }
        } else {
          resolve(true)
          // caso contrario, apenas colocar o arquivo na variavel files para ser usado depois
          // usa o formato de objeto pois com array estava criando um monte de posições anteriores vazias
          // state.files[payload['custom_field_id']] = payload['files']
        }
      })
    },
    delete_file (context, payload) {
      return new Promise((resolve, reject) => {
        let params = payload['params'] ? payload['params'] : ''
        // verificar se de deletar no banco/servidor
        if (payload['save_bd']) {
          Vue.http.delete(`api/files/${payload['id']}${params}`).then(
            (res) => {
              context.state.indexFile--
              // Tira o arquvo da lista de arquivos no campo personalizado 
              let customField = context.state.values.find((val) => { return val.id == payload['custom_field_id'] })
              if (customField) {
                customField['files'] = customField['files'].filter((val) => { return val['id'] !== payload['id'] })
              }
              resolve(res.body)
            },
            err => {
              console.log(err)
              reject(err)
            }
          )
        } else {
          context.state.indexFile--
          // Tira o arquvo da lista de arquivos no campo personalizado 
          let customField = context.state.values.find((val) => { return val.id == payload['custom_field_id'] })
          if (customField) {
            customField['files'] = customField['files'].filter((val) => { return val['id'] !== payload['id'] })
          }
          // Tira o arquvo da lista de arquivos para adiciona
          if (context.state.files[payload['custom_field_id']]) {
            context.state.files[payload['custom_field_id']] = context.state.files[payload['custom_field_id']].filter((val) => {
              return val.get('id') != payload['id']
            })
          }
          resolve(true)
        }
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/customFieldConnection.js